import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

const eventFeedbackQuery = gql`
  query EventFeedbackQuery($eventId: Int!) {
    guestStats(eventId: $eventId) {
      confirmed
      attended
    }
    feedbackStats(eventId: $eventId) {
      feedbackSubmitted
    }
  }
`;

export interface EditEventFeedbackData {
  guestStats: {
    confirmed: number;
    attended: number;
  };
  feedbackStats: {
    feedbackSubmitted: number;
  };
}

export const getEditEventFeedbackData = (eventId: number): Promise<EditEventFeedbackData> => {
  return gqlClient.request<EditEventFeedbackData>(eventFeedbackQuery, { eventId });
};
